import React, { useState, createContext, useContext } from "react"

const TabsContext = createContext()

const Tabs = ({ children, value, onValueChange, ...props }) => {
  const [activeTab, setActiveTab] = useState(value)
  
  const handleTabChange = (newValue) => {
    setActiveTab(newValue)
    if (onValueChange) onValueChange(newValue)
  }

  return (
    <TabsContext.Provider value={{ activeTab, handleTabChange }}>
      <div {...props}>
        {children}
      </div>
    </TabsContext.Provider>
  )
}

const TabsList = ({ className = "", children, ...props }) => (
  <div
    className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1 text-gray-500 ${className}`}
    {...props}
  >
    {children}
  </div>
)

const TabsTrigger = ({ className = "", value, children, ...props }) => {
  const { activeTab, handleTabChange } = useContext(TabsContext)
  const isActive = activeTab === value

  return (
    <button
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 ${
        isActive 
          ? 'bg-white text-gray-900 shadow-sm' 
          : 'hover:bg-gray-200 hover:text-gray-900'
      } ${className}`}
      onClick={() => handleTabChange(value)}
      {...props}
    >
      {children}
    </button>
  )
}

const TabsContent = ({ className = "", value, children, ...props }) => {
  const { activeTab } = useContext(TabsContext)
  if (activeTab !== value) return null

  return (
    <div
      className={`mt-2 focus-visible:outline-none focus-visible:ring-2 ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }